module.exports = __webpack_public_path__ + "static/media/add_panel.6c82e3eb.svg";